import React, { useEffect, useState } from "react";
import MuiButton from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Alert from '@mui/material/Alert';
import pxToRem from "libs/pxToRem";
import Modal from "components/styled/modal/Modal";
import { styled } from '@mui/material/styles';
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { Typography } from "@mui/material";
import { SolicitudConsumoAnalisisResponse } from "api/types/originacion/services/analisisSolicitudTypes";

const AnularLiquidacion: React.FC<{
  handleAnularLiquidacion: (motivo: string) => void;
  isLoading: boolean;
  solicitud: SolicitudConsumoAnalisisResponse;
  error?: string | null;
  isSuccess?: boolean;
  onClearError?: () => void;
}> = ({
  handleAnularLiquidacion,
  isLoading,
  solicitud,
  error,
  isSuccess,
  onClearError,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [motivo, setMotivo] = useState("");
  const canSubmit = motivo !== "" && !isLoading;

  useEffect(() => {
    if (isSuccess && modalIsOpen) {
      handleClose();
    }
  }, [isSuccess]);

  const formatMotivo = (text: string): string => {
    if (!text || text.trim() === "") return "";

    let formatted = text.trim();
    formatted = formatted.toLowerCase();
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);

    if (!formatted.endsWith(".")) {
      formatted += ".";
    }

    return formatted;
  };

  const handleClose = () => {
    setModalIsOpen(false);
    setMotivo("");
    onClearError?.();
  };

  const handleSubmit = () => {
    const motivoFormateado = formatMotivo(motivo);
    handleAnularLiquidacion(motivoFormateado);
  };

  return (
    <>
      <Button onClick={(e) => setModalIsOpen(!modalIsOpen)}>
        Anular Liquidación
      </Button>
      <Modal
        maxWidth="sm"
        opened={modalIsOpen}
        onClose={handleClose}
        title="Anular liquidación"
        dialogActions={
          <ModalButton disabled={!canSubmit} onClick={handleSubmit}>
            {isLoading && "Anulando..."}
            {!isLoading && "Anular"}
          </ModalButton>
        }
      >
        <ModalContent>
          <IdSection>
            <DescriptionOutlinedIcon
              style={{ color: "hsl(263, 55%, 53%)", fontSize: pxToRem(20) }}
            />
            <IdText>Solicitud #{solicitud.id}</IdText>
          </IdSection>

          {error && (
            <Alert
              severity="error"
              style={{
                maxWidth: pxToRem(380),
                overflowY: "auto",
              }}
            >
              {error}
            </Alert>
          )}

          <TextField
            onChange={(e) => {
              setMotivo(e.target.value);
            }}
            value={motivo}
            placeholder="Motivo"
            multiline
            minRows={4}
            variant="outlined"
            style={{ width: pxToRem(380), marginTop: pxToRem(5) }}
          />
        </ModalContent>
      </Modal>
    </>
  );
};
export default AnularLiquidacion;

const Button = styled(MuiButton)({
  height: pxToRem(28),
  marginLeft: pxToRem(8),
  whiteSpace: "nowrap",
  backgroundColor: "#f44336",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#f35858",
  },
});
Button.defaultProps = {
  variant: "contained",
  size: "small",
};

const ModalButton = styled(MuiButton)({
  backgroundColor: "#f44336",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#f35858",
  },
  minWidth: pxToRem(140),
});
ModalButton.defaultProps = {
  variant: "contained",
  color: "secondary",
  size: "small",
  fullWidth: false,
};

const ModalContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(16),
  padding: pxToRem(16),
});

const IdSection = styled("div")({
  backgroundColor: "#f5f5f5",
  borderLeft: `${pxToRem(4)} solid hsl(190, 63%, 57%)`,
  padding: `${pxToRem(12)} ${pxToRem(16)}`,
  borderRadius: pxToRem(4),
  display: "flex",
  alignItems: "center",
  gap: pxToRem(10),
});

const IdText = styled(Typography)({
  fontSize: pxToRem(15),
  fontWeight: 600,
  color: "#424242",
  margin: 0,
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
});
